import React, { useState } from "react";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { X, Target } from "@phosphor-icons/react";

export default function EditEquipmentTargetsModal({ equipmentId, equipmentName, initial, onClose, onSaved }) {
    const [f, setF] = useState({
        availability_pct: initial?.availability_pct ?? 90,
        utilisation_pct: initial?.utilisation_pct ?? 85,
        reliability_pct: initial?.reliability_pct ?? 90,
        mtbf_hrs: initial?.mtbf_hrs ?? 48,
    });
    const [saving, setSaving] = useState(false);

    const submit = async () => {
        try {
            setSaving(true);
            await api.post(`/equipment/${equipmentId}/targets`, {
                availability_pct: parseFloat(f.availability_pct) || 0,
                utilisation_pct: parseFloat(f.utilisation_pct) || 0,
                reliability_pct: parseFloat(f.reliability_pct) || 0,
                mtbf_hrs: parseFloat(f.mtbf_hrs) || 0,
            });
            onSaved && onSaved();
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="fixed inset-0 z-[90] bg-slate-900/85 flex items-start sm:items-center justify-center p-2 overflow-y-auto" data-testid="edit-targets-modal">
            <div className="bg-white rounded-lg w-full max-w-md shadow-xl border border-slate-200 relative">
                <button onClick={onClose} className="absolute top-3 right-3 w-8 h-8 rounded-full bg-slate-100 hover:bg-slate-200 flex items-center justify-center" data-testid="edit-targets-close"><X size={16} /></button>
                <div className="px-5 py-4 border-b border-slate-200">
                    <div className="uppercase-label text-[10px] text-[var(--grindrod-red)] flex items-center gap-1"><Target size={11} weight="bold" /> Performance Targets</div>
                    <h3 className="font-display font-black text-xl text-[var(--grindrod-navy)]">{equipmentName}</h3>
                </div>
                <div className="p-5 grid grid-cols-2 gap-3">
                    <Field label="Availability target (%)">
                        <input type="number" step="0.1" min="0" max="100" value={f.availability_pct} onChange={(e) => setF({ ...f, availability_pct: e.target.value })} className="g-input tabular" data-testid="target-availability" />
                    </Field>
                    <Field label="Utilisation target (%)">
                        <input type="number" step="0.1" min="0" max="100" value={f.utilisation_pct} onChange={(e) => setF({ ...f, utilisation_pct: e.target.value })} className="g-input tabular" data-testid="target-utilisation" />
                    </Field>
                    <Field label="Reliability target (%)">
                        <input type="number" step="0.1" min="0" max="100" value={f.reliability_pct} onChange={(e) => setF({ ...f, reliability_pct: e.target.value })} className="g-input tabular" data-testid="target-reliability" />
                    </Field>
                    <Field label="MTBF target (hours)">
                        <input type="number" step="0.1" min="0" value={f.mtbf_hrs} onChange={(e) => setF({ ...f, mtbf_hrs: e.target.value })} className="g-input tabular" data-testid="target-mtbf" />
                    </Field>
                </div>
                <div className="px-5 py-3 border-t border-slate-200 flex justify-end gap-2">
                    <button onClick={onClose} className="text-sm px-3 py-2 rounded-sm bg-slate-100 hover:bg-slate-200">Cancel</button>
                    <button onClick={submit} disabled={saving} className="text-sm px-3 py-2 rounded-sm bg-[var(--grindrod-navy)] text-white disabled:opacity-60" data-testid="target-save-btn">{saving ? "Saving…" : "Save targets"}</button>
                </div>
            </div>
        </div>
    );
}

function Field({ label, children }) {
    return (
        <label className="block">
            <span className="text-[11px] uppercase tracking-wider text-slate-500 font-bold block mb-1">{label}</span>
            {children}
        </label>
    );
}
